import React from "react";

function CPrograms() {
    return (
        <ul>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://github.com/code50/88984297/blob/main/population/population.c">Lab 1: Population</a>&#160;– Calculating the years it will take for a population to reach a specified quantity.
            </li>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://github.com/code50/88984297/blob/main/mario-more/mario.c">Mario (More)</a>&#160;– Generating Mario blocks as “#” symbols based on the input of an integer.
            </li>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://github.com/code50/88984297/blob/main/cash/cash.c">Lab 1: Cash</a>&#160;– Returning the least amount of coins needed to make up an integer input representing cash.
            </li>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://github.com/code50/88984297/blob/main/scrabble/scrabble.c">Lab 2: Scrabble</a>&#160;– Imitating a single-round Scrabble game between two players.
            </li>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://github.com/code50/88984297/blob/main/readability/readability.c">Readability</a>&#160;– Using the Coleman-Liau index formula to evaluate a string’s reading grade level.
            </li>
            <li>
                <a target="_blank" rel="noopener noreferrer" href="https://github.com/code50/88984297/blob/main/wordle/wordle.c">Wordle</a>&#160;– Imitating The New York Time’s game Wordle.
            </li>
        </ul>
    )
}

export default CPrograms;